<script setup lang="ts">
    import { UserCompany } from '@/types';
    import { useI18n } from 'vue-i18n';

    defineProps<{
        userCompany: UserCompany;
    }>();

    const { t } = useI18n();
</script>

<template>
    {{ userCompany.name }}
    <span
        v-if="userCompany.deactivated_at"
        class="text-destructive text-xs"
    >
        ({{ t('companies.deactivated') }})
    </span>
</template>
